"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={padding:"8px 12px 8px 14px",minHeight:"40px",display:"flex",alignItems:"center"};exports.paperStyles=e;
